module.exports = __webpack_public_path__ + "img/success.7c0f7d55.png";